import React, {useState, useEffect} from 'react';
import { formatDate } from 'react-day-picker/moment';

import TextNumber from '../../../components/text-number';
import Note from '../../../components/note';
import Label from '../../../components/label';
import FilterButton from '../../../components/filter-button';
import LinkButton from '../../../components/link-button';
import {getData} from '../../../helper/request-response';
import DayPicker from '../../../components/day-picker';
import constant from '../../../config/constant';
import receivablePath from './config';

const List = () => {

    const [receivables, setReceivables] = useState([]);

    const getDetailPath = (invoiceNo) => receivablePath.detailPath.replace(":id", invoiceNo);

    const [receivableFilter, setFilterReceivable] = useState({
        trxDate: "",
        customerName: ""
    });

    const onInputChange = e => {

        setFilterReceivable({ 
            ...receivableFilter,
            [e.target.name]: e.target.value
        });
    };

    const onDayChange = day => {

        setFilterReceivable(trx => ({ 
            ...trx,
            trxDate: formatDate(day, constant.DEFAULT_DATE)
        }));
    }

    const onSubmit = e => {

        e.preventDefault();

        const params = { 
            params: {
                trxDate: receivableFilter.trxDate,
                customerName: receivableFilter.customerName,
            }
        };

        getReceivables(params);

    };

    const getReceivables = async(params) => {

        const result = await getData(receivablePath.baseApi, params);
            
        setReceivables(result);

    }

    const onReset = e => {

        e.preventDefault();

        setFilterReceivable(trx => ({ 
            ...receivableFilter,
            trxDate: "",
            customerName: ""
        }));

        getReceivables();

    }

    useEffect(() => { 

        getReceivables();

     }, []);
    

    return(
        <React.Fragment>
            <div className="card-header">
                <h3 className="h6 text-uppercase mb-0">{receivablePath.title}</h3>
            </div>
            <div className="card-body">
            <div className="row">
                    <div className="col-md-8 border-right">
                        <form className="form-horizontal" onSubmit={ e => onSubmit(e) } >

                            <div className="form-group row">
                                <Label htmlFor="trx-date" isCol={ true } text="Tanggal Pembelian" />
                                <div className="col-md-9">
                                    <DayPicker id="trx-date" name="trxDate" onDayChange={ onDayChange } />
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label htmlFor="receivable-customerName" isCol={ true } text="Nama Pelanggan" />
                                <div className="col-md-9">
                                    <input 
                                        id="receivable-customerName" 
                                        type="text" 
                                        className="form-control"
                                        name="customerName"
                                        value={ receivableFilter.customerName }
                                        onChange={ e => onInputChange(e) } />
                                </div>
                            </div>

                            <div className="form-group row">
                                <Label isCol={ true } />
                                <div className="col-md-9">
                                    <FilterButton to={ receivablePath.newPath } newLabel="Tambah Penagihan Baru" onClick={ onReset } />
                                </div>
                            </div>

                        </form>
                    </div>

                    <div className="col-md-4">
                        <Note isFilter={ true } label="Tambah Transaksi Baru" entity="Transaksi" />
                    </div>
                </div>

                <div className="col-lg-12 mb-4">
                    <div className="row">
                        <table className="table table-striped table-hover card-text">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>No Pembayaran</th>
                                    <th>Tanggal</th>
                                    <th>Nama Pelanggan</th>
                                    <th>Keterangan</th>
                                    <th>Jumlah</th>
                                    <th>Opsi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    receivables.map((receivable, index) => {
                                        const ket = receivable.description.split('-');
                                        return(
                                            <tr key={index}>
                                                <th scope="row">{ index + 1 }</th>
                                                <td>{ receivable.invoiceNo }</td>
                                                <td>{ `${formatDate(receivable.trxDate, 'LL', constant.LOCALE)}` } </td>
                                                <td>{ receivable.custName }</td>
                                                <td>{ ket.length > 1 ? ket[1] : 'PEMBAYARAN HUTANG' }</td>
                                                <td><TextNumber value={ receivable.amount } /></td>
                                                <td><LinkButton to={ {pathname: getDetailPath(receivable.invoiceNo), state: receivable} } /></td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default List;
